<template>
  <aside 
    class="w-64 bg-white dark:bg-gray-800 text-[#035a76] dark:text-gray-200 shadow-lg flex-shrink-0 fixed h-full z-10 transition-all duration-300"
    :class="{'ml-0': isOpen, '-ml-64': !isOpen}"
  >
    <div class="p-6 flex items-center space-x-2 border-b border-gray-200 dark:border-gray-700">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
      </svg>
      <span class="text-sm md:text-2xl font-bold">School HR</span>
    </div>
<nav class="mt-6 overflow-y-auto h-[calc(100%-80px)] scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100 dark:scrollbar-thumb-gray-600 dark:scrollbar-track-gray-800">
        <ul class="space-y-1 px-2 pb-6">
        <!-- Dashboard -->
        <li>
          <RouterLink 
            :to="{ name: 'hrdashboard'}" 
            class="flex items-center px-6 py-3 text- hover:bg-[#74bd54] hover:text-white transition-colors duration-200 dark:hover:bg-gray-700"
            active-class="router-link-active"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
            Dashboard
          </RouterLink>
        </li>

        <!--Checklist-->

          <li v-if="canAccessModule('checklist')">
          <RouterLink 
            to="/checklist" 
            class="flex items-center px-6 py-3 hover:bg-[#74bd54] hover:text-white transition-colors duration-200 dark:hover:bg-gray-700"
            active-class="router-link-active"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                    d="M9 12l2 2 4-4m1 8H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2z" />
            </svg>
           {{ $t ('sidebar.checklist') }}
          </RouterLink>
        </li>

        <!-- Manpower -->
        <li v-if="canAccessModule('manpower')">
          <RouterLink 
            to="/manpower" 
            class="flex items-center px-6 py-3 hover:bg-[#74bd54] hover:text-white transition-colors duration-200 dark:hover:bg-gray-700"
            active-class="router-link-active"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a4 4 0 00-3-3.87M9 20h6m-3-4a4 4 0 100-8 4 4 0 000 8zm6-4a6 6 0 00-12 0v5h12v-5z" />
            </svg>
            {{ $t('sidebar.manpower') }}
          </RouterLink>
        </li>
        <li v-if="canAccessModule('users')">
          <RouterLink 
            to="/hr-users" 
            class="flex items-center px-6 py-3 hover:bg-[#74bd54] hover:text-white transition-colors duration-200 dark:hover:bg-gray-700"
            active-class="router-link-active"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a4 4 0 00-3-3.87M9 20h6m-3-4a4 4 0 100-8 4 4 0 000 8zm-6-4a6 6 0 0112 0v5H3v-5z" />
            </svg>
            {{ $t('sidebar.users') }}
          </RouterLink>
        </li>
        <li>
          <RouterLink 
            to="/audit-logs" 
            class="flex items-center px-6 py-3 hover:bg-[#74bd54] hover:text-white transition-colors duration-200 dark:hover:bg-gray-700"
            active-class="router-link-active"
          >
<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
        d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2" />
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
        d="M9 17h6M9 13h6" />
</svg>
            {{ $t('audits') }}
          </RouterLink>
        </li>

        
        <!-- Staff Management -->
        <li class="px-6 py-2 text-xs font-semibold text-gray-500 uppercase tracking-wider">
          Staff Management
        </li>
        
        <!-- Onboarding -->
        <li>
          <RouterLink 
            to="/onboarding" 
            class="flex items-center px-6 py-3 hover:bg-[#74bd54] hover:text-white transition-colors duration-200 dark:hover:bg-gray-700"
            active-class="router-link-active"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
            </svg>
            {{ $t('sidebar.onboarding') }}
          </RouterLink>
        </li>
        
        <!-- Contracts -->
        <li v-if="canAccessModule('contracts')">
          <RouterLink 
            to="/contracts" 
            class="flex items-center px-6 py-3 hover:bg-[#74bd54] hover:text-white transition-colors duration-200 dark:hover:bg-gray-700"
            active-class="router-link-active"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
            </svg>
            {{ $t('sidebar.contracts') }}
          </RouterLink>
        </li>
        
        <!-- Staff Directory -->
        <li>
          <RouterLink 
            to="/staff" 
            class="flex items-center px-6 py-3 hover:bg-[#74bd54] hover:text-white transition-colors duration-200 dark:hover:bg-gray-700"
            active-class="router-link-active"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
            {{ $t('sidebar.staffDirectory') }}
          </RouterLink>
        </li>
        
        <!-- Attendance -->
        <li>
          <RouterLink 
            to="/attendance" 
            class="flex items-center px-6 py-3 hover:bg-[#74bd54] hover:text-white transition-colors duration-200 dark:hover:bg-gray-700"
            active-class="router-link-active"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
            </svg>
            {{ $t('sidebar.attendance') }}
          </RouterLink>
        </li>
        
        <!-- Leave Management -->
        <li>
          <RouterLink 
            to="/leave" 
            class="flex items-center px-6 py-3 hover:bg-[#74bd54] hover:text-white transition-colors duration-200 dark:hover:bg-gray-700"
            active-class="router-link-active"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            {{$t('sidebar.leaveManagement')}}
          </RouterLink>
        </li>
        
        <!-- Payroll -->
        <li class="px-6 py-2 text-xs font-semibold text-gray-500 uppercase tracking-wider">
          Payroll & Benefits
        </li>
        
        <!-- Payroll -->
        <!-- <li>
          <RouterLink 
            to="/payroll" 
            class="flex items-center px-6 py-3 hover:bg-[#04698f] hover:text-white transition-colors duration-200 dark:hover:bg-gray-700"
            active-class="router-link-active"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Payroll
          </RouterLink>
        </li> -->
        
        <!-- Loans & Advances -->
        <li>
          <RouterLink 
            to="/loans" 
            class="flex items-center px-6 py-3 hover:bg-[#74bd54] hover:text-white transition-colors duration-200 dark:hover:bg-gray-700"
            active-class="router-link-active"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            {{$t('sidebar.loansAdvance')}}
          </RouterLink>
        </li>
        
        <!-- Performance -->
        <li class="px-6 py-2 text-xs font-semibold text-gray-500 uppercase tracking-wider">
          Performance
        </li>
        
        <!-- Appraisals -->
        <li>
          <RouterLink 
            to="/appraisals" 
            class="flex items-center px-6 py-3 hover:bg-[#74bd54] hover:text-white transition-colors duration-200 dark:hover:bg-gray-700"
            active-class="router-link-active"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
            {{$t('sidebar.appraisals')}}
          </RouterLink>
        </li>
        <li>
            <a 
              href="http://localhost/ecole_ronsard_elearning/admin/" 
              target="_blank" 
              class="flex items-center px-6 py-3 hover:bg-[#74bd54] hover:text-white transition-colors duration-200 dark:hover:bg-gray-700"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
              </svg>
              {{$t('sidebar.trainingDevelopment')}}
            </a>
          </li>
        <!-- Training -->
        <!-- <li>
          <RouterLink 
            to="http://www.localhost/ecole_ronsard_elearning/admin/" 
            class="flex items-center px-6 py-3 hover:bg-[#04698f] hover:text-white transition-colors duration-200 dark:hover:bg-gray-700"
            active-class="router-link-active"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
            </svg>
            Training & Development
          </RouterLink>
        </li> -->
        
        <!-- Discipline -->
        <li>
          <RouterLink 
            to="/discipline" 
            class="flex items-center px-6 py-3 hover:bg-[#74bd54] hover:text-white transition-colors duration-200 dark:hover:bg-gray-700"
            active-class="router-link-active"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
            Discipline
          </RouterLink>
        </li>
        
        <!-- Reports -->
        <li class="px-6 py-2 text-xs font-semibold text-gray-500 uppercase tracking-wider">
          Reports
        </li>
        
        <!-- HR Reports -->
        <li>
          <RouterLink 
            to="/reports" 
            class="flex items-center px-6 py-3 hover:bg-[#74bd54] hover:text-white transition-colors duration-200 dark:hover:bg-gray-700"
            active-class="router-link-active"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
                      {{$t('sidebar.hrReports')}}

          </RouterLink>
        </li>
        <li>
  <!-- Master Data Button -->
  <button
    @click="toggleMasterData"
    class="flex items-center justify-between w-full px-6 py-3 hover:bg-[#74bd54] hover:text-white transition-colors duration-200 dark:hover:bg-gray-700"
  >
    <div class="flex items-center">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M4 6h16M4 12h16M4 18h16" />
      </svg>
       {{$t('sidebar.masterData')}}
    </div>

    <!-- Arrow -->
    <svg
      :class="{ 'rotate-180': showMasterData }"
      class="h-4 w-4 transition-transform duration-200"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
        d="M19 9l-7 7-7-7" />
    </svg>
  </button>

  <!-- Submenu -->
  <ul v-show="showMasterData" class="bg-gray-100 dark:bg-gray-800">

    <li>
      <RouterLink to="/departments"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        {{$t('sidebar.departments')}}
      </RouterLink>
    </li>

    <li>
      <RouterLink to="/positions"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        {{$t('sidebar.positions')}}
      </RouterLink>
    </li>

    <li>
      <RouterLink to="/contract-types"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        {{$t('sidebar.contractTypes')}}
      </RouterLink>
    </li>
    <li>
      <RouterLink to="/process-types"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        {{$t('sidebar.processTypes')}}
      </RouterLink>
    </li>
    <li>
      <RouterLink to="/allowances"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        {{$t('sidebar.allowances')}}
      </RouterLink>
    </li>
    <li>
      <RouterLink to="/contract-status"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        {{$t('sidebar.contractStatus')}}
      </RouterLink>
    </li>
        <li>
      <RouterLink to="/agency"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        {{$t('sidebar.agencies')}}
      </RouterLink>
    </li>
    <li>
      <RouterLink to="/leave-types"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        {{$t('sidebar.leaveTypes')}}
      </RouterLink>
    </li>
    <li>
      <RouterLink to="/interview-questions"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        {{$t('sidebar.interviewQuestions')}}
      </RouterLink>
    </li>
        <li>
      <RouterLink to="/interview-evaluation"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        {{$t('sidebar.interviewEvaluation')}}
      </RouterLink>
    </li>
    <li>
      <RouterLink to="/employee-actions"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        {{$t('sidebar.employeeActions')}}
      </RouterLink>
    </li>

    <li>
      <RouterLink to="/attendance-status"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        {{$t('sidebar.attendanceStatus')}}
      </RouterLink>
    </li>
    <li>
      <RouterLink to="/working-hours"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        {{$t('sidebar.workingHours')}}
      </RouterLink>
    </li>
    <li>
      <RouterLink to="/sections"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        Sections
      </RouterLink>
    </li>
    <li>
      <RouterLink to="/classes"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        Classes
      </RouterLink>
    </li>
        <li>
      <RouterLink to="/subjects"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        {{$t('sidebar.subjects')}}
      </RouterLink>
    </li>
            <li v-if="canAccessModule('modules')">
      <RouterLink to="/modules"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        Modules
      </RouterLink>
    </li>
            <!-- <li>
      <RouterLink to="/permissions"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        Permissions
      </RouterLink>
      
    </li> -->
      <li v-if="canAccessModule('permissions')">
      <RouterLink to="/user-permission"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        {{$t('sidebar.userPermission')}}
      </RouterLink>
      
    </li>  
  </ul>
</li>
      </ul>
    </nav>
  </aside>
</template>

<script setup>
import { ref } from 'vue';
import { usePermissions } from '@/composables/usePermissions'

defineProps({
  isOpen: {
    type: Boolean,
    required: true
  }
});
const showMasterData = ref(false)

const toggleMasterData = () => {
  showMasterData.value = !showMasterData.value
}

const { canAccessModule } = usePermissions()
</script>

<style scoped>
.router-link-active {
  background-color: #74bd54;
  color: white !important;
  font-weight: 600;
}
</style>